import {
  AlarmClock,
  AlertCircle,
  AlertTriangle,
  AppWindow,
  ArrowDownToLine,
  ArrowLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUpToLine,
  AudioWaveform,
  Bell,
  Bone,
  BookCopy,
  BoxSelect,
  Braces,
  Calendar,
  CalendarX2Icon,
  Check,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsUp,
  ChevronsUpDown,
  Circle,
  CircleDot,
  CircleFadingArrowUp,
  CircleHelp,
  CirclePlay,
  CircleX,
  ClipboardCopy,
  ClipboardEdit,
  ClipboardPaste,
  ClipboardPen,
  Clock,
  CloudDownload,
  CloudUpload,
  Copy,
  CopyPlus,
  CornerDownLeft,
  Download,
  Ellipsis,
  EllipsisVertical,
  Equal,
  ExternalLink,
  Eye,
  FastForward,
  FileBracesCorner,
  FileEdit,
  FileExclamationPoint,
  FileInput,
  FileSymlink,
  FileText,
  FileUp,
  Files,
  FlagTriangleRight,
  FlaskConical,
  Gavel,
  Gem,
  Grip,
  GripVertical,
  Heading1,
  Heading2,
  Heading3,
  HeartHandshake,
  HelpCircle,
  History,
  Home,
  Import,
  Info,
  LayoutTemplate,
  Lightbulb,
  Link,
  List,
  ListFilter,
  ListOrdered,
  Loader2Icon,
  LoaderCircle,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Maximize2,
  Menu,
  Merge,
  MessageSquare,
  MessageSquarePlus,
  MessageSquareText,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MinusCircle,
  MoreHorizontal,
  Paperclip,
  Pause,
  PauseCircle,
  Pencil,
  Pill,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Puzzle,
  RadioTower,
  RefreshCcw,
  RefreshCw,
  Rewind,
  RotateCcw,
  RotateCw,
  Save,
  Scaling,
  Search,
  Send,
  SeparatorHorizontal,
  SeparatorVertical,
  Settings,
  Settings2,
  ShieldCheck,
  SlidersHorizontal,
  Square,
  SquareArrowOutUpRight,
  SquareCheckBig,
  SquarePen,
  Squircle,
  Star,
  Stethoscope,
  Tag,
  Text,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Type,
  Undo2,
  Unlock,
  Upload,
  User,
  UserPlus,
  UserRoundPlus,
  UserRoundSearch,
  Users,
  Wand,
  WandSparkles,
  X,
} from 'lucide-react';
import React from 'react';

import { VariantProps, cn, tv } from './cn';

const styles = tv({
  base: 'shrink-0',
  variants: {
    size: {
      '2xs': 'size-3.5 stroke-[2.1px]',
      xs: 'size-4 stroke-[1.9px]',
      sm: 'size-5 stroke-[1.8px]',
      md: 'size-6 stroke-[2.0px]',
      lg: 'size-7 stroke-[1.9px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const Icons = {
  AlarmClock,
  AlertCircle,
  AlertTriangle,
  AppWindow,
  ArrowDownToLine,
  ArrowLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUpToLine,
  AudioWaveform,
  Bell,
  Bone,
  BookCopy,
  BoxSelect,
  Braces,
  Calendar,
  CalendarX2Icon,
  Check,
  CheckCircle2,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsDownUp,
  ChevronsUp,
  ChevronsUpDown,
  ChevronUp,
  Circle,
  CircleDot,
  CircleFadingArrowUp,
  CircleHelp,
  CirclePlay,
  CircleX,
  ClipboardCopy,
  ClipboardEdit,
  ClipboardPaste,
  ClipboardPen,
  Clock,
  CloudDownload,
  CloudUpload,
  Copy,
  CopyPlus,
  CornerDownLeft,
  Download,
  Ellipsis,
  EllipsisVertical,
  Equal,
  ExternalLink,
  Eye,
  FastForward,
  FileBracesCorner,
  FileExclamationPoint,
  FileEdit,
  FileInput,
  Files,
  FileSymlink,
  FileText,
  FileUp,
  FlagTriangleRight,
  FlaskConical,
  Gavel,
  Gem,
  Grip,
  GripVertical,
  Heading1,
  Heading2,
  Heading3,
  HeartHandshake,
  HelpCircle,
  History,
  Home,
  Import,
  Info,
  LayoutTemplate,
  Lightbulb,
  Link,
  List,
  ListFilter,
  ListOrdered,
  Loader2Icon,
  LoaderCircle,
  Lock,
  LogOut,
  Mail,
  MapPin,
  Maximize2,
  Menu,
  Merge,
  MessageSquare,
  MessageSquarePlus,
  MessageSquareText,
  Mic,
  MicOff,
  Minimize2,
  Minus,
  MinusCircle,
  MoreHorizontal,
  Paperclip,
  Pause,
  PauseCircle,
  Pencil,
  Pill,
  Play,
  PlayCircle,
  Plus,
  PlusCircle,
  Puzzle,
  RadioTower,
  RefreshCcw,
  RefreshCw,
  Rewind,
  RotateCcw,
  RotateCw,
  Save,
  Scaling,
  Search,
  Send,
  SeparatorHorizontal,
  SeparatorVertical,
  Settings,
  Settings2,
  ShieldCheck,
  SlidersHorizontal,
  Square,
  SquareArrowOutUpRight,
  SquareCheckBig,
  SquarePen,
  Squircle,
  Star,
  Stethoscope,
  Tag,
  Text,
  ThumbsDown,
  ThumbsUp,
  Trash,
  Type,
  Undo2,
  Unlock,
  Upload,
  User,
  Users,
  UserPlus,
  UserRoundPlus,
  UserRoundSearch,
  Wand,
  WandSparkles,
  X,
};

export type IconNames = keyof typeof Icons;

export type IconProps = VariantProps<typeof styles> & {
  className?: string;
  name: IconNames;
};

export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ name, size, className }, ref) => {
    const Component = Icons[name];
    const classes = styles({ size, className });

    return <Component ref={ref} className={classes} />;
  },
);

/**
 * A reusable component that renders an animated loader icon.
 *
 * @param size - The size of the icon.
 * @param className - Additional CSS classes to apply to the icon.
 * @param ref - Ref forwarded to the inner SVG element.
 *
 * @returns An animated loader icon.
 */
export const LoadingIcon = React.forwardRef<
  SVGSVGElement,
  Omit<IconProps, 'name'>
>(({ size, className }, ref) => {
  return (
    <Icons.LoaderCircle
      ref={ref}
      className={cn(
        styles({ size, className }),
        '[&>path]:origin-center [&>path]:animate-spin',
      )}
    />
  );
});
